import { Spinner } from 'react-bootstrap';

export interface LoadingSpinnerProps {
  label?: string;
  fullPage?: boolean;
  size?: 'sm' | undefined;
}

export function LoadingSpinner({
  label = 'Loading…',
  fullPage = false,
  size,
}: LoadingSpinnerProps) {
  const content = (
    <div className="d-flex align-items-center justify-content-center gap-2 text-muted py-4">
      <Spinner animation="border" role="status" size={size} />
      <span>{label}</span>
    </div>
  );
  if (fullPage) {
    return <div className="d-flex align-items-center justify-content-center vh-100">{content}</div>;
  }
  return content;
}
